/**
 * Dispara o download de um Blob no navegador.
 */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

/**
 * Lê o nome do arquivo do header Content-Disposition, caindo no fallback quando ausente.
 */
export function filenameFromResponse(response, fallback) {
  const disposition = response?.headers?.['content-disposition']
  if (disposition == null || disposition === '') return fallback

  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
  return match == null ? fallback : decodeURIComponent(match[1])
}
